import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  Table,
  Text,
  Link,
  Container,
  CenteredMessage,
  DeletedLabel,
  InlineTextContainer,
} from './styles';
import formatBytes from '../../../../../core/utils/format-bytes';

const CustomTable = ({ dataList }) => (
  <Container>
    {dataList.length === 0 ? (
      <CenteredMessage>
        <Text data-zero-uploads>You haven’t uploaded research yet</Text>
      </CenteredMessage>
    ) : (
      <Table basic="very">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <Text.Bold>Date</Text.Bold>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Text.Bold>Project Name</Text.Bold>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Text.Bold>Participant Name</Text.Bold>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Text.Bold>Size</Text.Bold>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {dataList.map((item) => (
            <Table.Row key={item.id}>
              <Table.Cell>
                <Text>{moment(item.createdAt).format('LL')}</Text>
              </Table.Cell>
              <Table.Cell>
                <Link
                  href={`projects/${item.project.id}/study`}
                  rel="internal"
                  target="_blank"
                >
                  {item.project.name}
                </Link>
              </Table.Cell>
              <Table.Cell>
                {item.testSession.tester.removed ? (
                  <>
                    <InlineTextContainer>
                      <Text>
                        {`${item.testSession.tester.user.profile.firstName} ${item.testSession.tester.user.profile.lastName}`}
                      </Text>
                      <DeletedLabel>
                        [Deleted]
                      </DeletedLabel>
                    </InlineTextContainer>
                  </>
                ) : (
                  <Link
                    href={`projects/${item.project.id}/videos/${item.testSession.tester.id}`}
                    rel="internal"
                    target="_blank"
                  >
                    {`${item.testSession.tester.user.profile.firstName} ${item.testSession.tester.user.profile.lastName}`}
                  </Link>
                )}
              </Table.Cell>
              <Table.Cell>
                <Text>{formatBytes(item.consumedStorage)}</Text>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    )}
  </Container>
);

CustomTable.propTypes = {
  dataList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      project: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
      user: PropTypes.shape({
        profile: PropTypes.shape({
          firstName: PropTypes.string.isRequired,
          lastName: PropTypes.string.isRequired,
        }),
      }),
      testSession: PropTypes.shape({
        id: PropTypes.string.isRequired,
        tester: PropTypes.shape({
          id: PropTypes.string.isRequired,
        }),
      }),
      consumedStorage: PropTypes.number.isRequired,
    }),
  ).isRequired,
};

export default CustomTable;
